import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../constants/svgIcon';
import { PngIcon, SvgIcon } from '../../Molecules';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './BreadDonationPopup.module.css';

type BreadDonationPopupProps = {
  onPrimary: () => void;
};

export const BreadDonationPopup = (props: BreadDonationPopupProps) => {
  const { onPrimary } = props;
  const { t } = useTranslation();

  return (
    <BasicPopupContainer
      primaryButtonLabel={t('OK')}
      onPrimaryButtonClick={onPrimary}
    >
      <div className={styles.popupContent}>
        <SvgIcon
          name={SVGIconType.BreadDonate}
          width={80}
          height={80}
          color="#333333"
        />
        <div className={styles.title}>{t('Bread Donation')}</div>
        <div className={styles.subtitle}>
          {t(
            'When you donate bread, JOYAJOY will donate the same amount of bread to hungry children in the real world.',
          )}
        </div>
        <div className={styles.contentBox}>
          <PngIcon name="AuditorReport" width={60} height={60} />
          <div className={styles.contentText}>
            <span>{t('JOYAJOY Bread Donation is a charity project.')}</span>
            <span>
              {t(
                'An independent auditor report for JOYAJOY Bread Donation project will be posted on JOYAJOY website and app in the end of every year.',
              )}
            </span>
          </div>
        </div>
      </div>
    </BasicPopupContainer>
  );
};
